import { createCompoundComponent } from '../../utilities'
import { Title } from './components/Title'
import { ContentTeaserGroup as BaseContentTeaserGroup } from './ContentTeaserGroup'
import { Divider } from './components/Divider'

export type { ContentTeaserGroupProps } from './types'

export const ContentTeaserGroup = createCompoundComponent(
  BaseContentTeaserGroup,
  {
    Divider,
    Title,
  },
)
